/// <reference path="../../app.typings.d.ts" />
'use strict';
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var app;
(function (app) {
    var Services;
    (function (Services) {
        var SsoApiService = /** @class */ (function (_super) {
            __extends(SsoApiService, _super);
            function SsoApiService($cookies, $routeParams, $q, httpService, appSettings) {
                var _this = _super.call(this, httpService) || this;
                _this.$cookies = $cookies;
                _this.$routeParams = $routeParams;
                _this.$q = $q;
                _this.httpService = httpService;
                _this.appSettings = appSettings;
                _this.authDataCookieName = 'authorizationData';
                _this.baseUrl = _this.appSettings.urls.ssoApi + "/auth";
                _this.bufferInMinutes = 5;
                _this.oneMinuteInMilliseconds = 60 * 1000;
                _this.refreshingToken = false;
                _this.wlptDataCookieName = 'WPauthorizationData';
                return _this;
            }
            SsoApiService.prototype.getActiveApplicationRoles = function () {
                return this.get(this.baseUrl + "/application/roles");
            };
            SsoApiService.prototype.getUsersOrganizationsList = function () {
                return this.get(this.baseUrl + "/organization-units");
            };
            SsoApiService.prototype.getUserOrgListWithProducts = function () {
                return this.userOrgRoles;
            };
            SsoApiService.prototype.getUserRolesByOrg = function (orgCacheKey) {
                if (!ap.Utilities.isNullOrUndefined(this.userOrgRoles)) {
                    var org = this.userOrgRoles.find(function (x) { return x.organizationUnitCacheKey === orgCacheKey; });
                    if (!ap.Utilities.isNullOrUndefined(org)) {
                        return org.applicationRoles;
                    }
                }
                return undefined;
            };
            SsoApiService.prototype.renewAccessToken = function (authData) {
                var _this = this;
                if (this.refreshingToken && !ap.Utilities.isNullOrUndefined(this.authPromise)) {
                    return this.authPromise;
                }
                this.refreshingToken = true;
                var data = {
                    Token: authData.RefreshToken,
                    ApplicationCacheKey: this.appSettings.applicationCacheKey,
                    IncludePermissions: true
                };
                return this.authPromise = this.renew(this.baseUrl + "/refresh", data)
                    .then(function (newAuthData) {
                    if (ap.Utilities.isNullOrUndefined(newAuthData)) {
                        _this.refreshingToken = false;
                        return false;
                    }
                    _this.userOrgRoles = newAuthData.organization_units;
                    newAuthData.activeOrg = newAuthData.organization_units[0];
                    var authKey;
                    if (!ap.Utilities.isNullOrUndefined(_this.$routeParams.organizationCacheKey)) {
                        authKey = _this.$routeParams.organizationCacheKey;
                    }
                    else if (!ap.Utilities.isNullOrUndefined(_this.$cookies.getObject(_this.wlptDataCookieName))) {
                        var authCookie = _this.$cookies.getObject(_this.wlptDataCookieName);
                        authKey = authCookie.OrganizationUnitCacheKey;
                    }
                    else {
                        authKey = newAuthData.organization_units[0].organizationUnitCacheKey;
                    }
                    newAuthData.activeOrg = newAuthData.organization_units.find(function (x) { return x.organizationUnitCacheKey === authKey; });
                    authData.updateAuthData(newAuthData);
                    _this.refreshingToken = false;
                    return true;
                });
            };
            SsoApiService.$inject = [
                '$cookies',
                '$routeParams',
                '$q',
                'httpService',
                'appSettings'
            ];
            return SsoApiService;
        }(Services.BaseHttpService));
        Services.SsoApiService = SsoApiService;
        angular.module('app.Services')
            .service('ssoApiService', SsoApiService);
    })(Services = app.Services || (app.Services = {}));
})(app || (app = {}));
